import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AppHome = () => {

  const history = useNavigate();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      window.location.href = 'https://thelunaticproject.com/redes';
    }, 0);

    return () => clearTimeout(redirectTimeout);
  }, [history]);

  return (<></>);
}
